import { render, staticRenderFns } from "./DashBoardDirectorArea.vue?vue&type=template&id=1daaa8e0"
import script from "./DashBoardDirectorArea.vue?vue&type=script&lang=js"
export * from "./DashBoardDirectorArea.vue?vue&type=script&lang=js"
import style0 from "./DashBoardDirectorArea.vue?vue&type=style&index=0&id=1daaa8e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports